module.exports = __webpack_public_path__ + "assets/img/logitech-astrogaming.ea4af685.jpg";